module.exports = __webpack_public_path__ + "img/kovatek-web.f6f8fd51.png";